import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { trackStage } from "../api";
import { useLang } from "../i18n";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";

export default function LoginPrompt({ open, onOpenChange, message }) {
  const { t } = useLang();
  const navigate = useNavigate();
  const location = useLocation();
  const returnTo = encodeURIComponent(location.pathname + location.search);

  useEffect(() => {
    if (open) trackStage("login_prompt");
  }, [open]);

  const go = (mode) => {
    onOpenChange(false);
    const m = mode === "register" ? "mode=register&" : "";
    navigate(`/logowanie?${m}returnTo=${returnTo}`);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="login-prompt-dialog" className="max-w-md">
        <DialogHeader>
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-[#FEF2F2] text-[#DC143C]">
            <Lock size={18} />
          </span>
          <DialogTitle>{t("prompt.title")}</DialogTitle>
          <DialogDescription className="text-sm leading-relaxed text-slate-600">
            {message || t("prompt.default")}
          </DialogDescription>
        </DialogHeader>
        <div className="mt-4 flex flex-col gap-2">
          <Button
            data-testid="login-prompt-login-button"
            className="bg-[#DC143C] text-white hover:bg-[#B91C1C]"
            onClick={() => go("login")}
          >
            {t("nav.login")}
          </Button>
          <Button data-testid="login-prompt-register-button" variant="outline" onClick={() => go("register")}>
            {t("nav.register")}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
